import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import api from '../api/axiosConfig';
import './EsqueciSenhaPage.css';
import Footer from './Footer';

const EsqueciSenhaPage = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setSuccess(false);

    try {
      const response = await api.post('/api/esqueci-senha', { email });
      
      if (response.data.success) {
        setSuccess(true);
        setMessage(response.data.message);
        setEmail('');
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        setMessage(error.response.data.message);
      } else {
        setMessage(t('forgotPassword.errorMessage'));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="esqueci-senha-container">
      <div className="esqueci-senha-header">
        <button onClick={() => navigate('/login')} className="back-btn">{t('common.backToLogin')}</button>
        <Link to="/" className="logo-link">
          <div className="logo-wrapper-small">
            <div className="logo-circle-small">
              <img src="/logo.png" alt="IGL Coatings Logo" />
            </div>
          </div>
        </Link>
        <h1>{t('forgotPassword.title')}</h1>
        <p>{t('forgotPassword.subtitle')}</p>
      </div>

      <div className="esqueci-senha-content">
        <form onSubmit={handleSubmit} className="esqueci-senha-form">
          <div className="form-group">
            <label>{t('forgotPassword.email')} *</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t('forgotPassword.emailPlaceholder')}
              required
            />
          </div>

          {message && (
            <div className={`form-message ${success ? 'form-message-success' : 'form-message-error'}`}>
              {message}
            </div>
          )}

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? t('forgotPassword.submitting') : t('forgotPassword.submit')}
          </button>

          {success && (
            <button type="button" className="go-login-btn" onClick={() => navigate('/login')}>
              {t('forgotPassword.backToLogin')}
            </button>
          )}
        </form>

        <div className="esqueci-senha-info">
          <div className="info-card">
            <div className="info-icon">📧</div>
            <h3>{t('forgotPassword.howItWorks')}</h3>
            <p>{t('forgotPassword.step1')}</p>
            <p>{t('forgotPassword.step2')}</p>
            <p>{t('forgotPassword.step3')}</p>
          </div>
          
          <div className="info-card">
            <div className="info-icon">⏱️</div>
            <h3>{t('forgotPassword.notReceived')}</h3>
            <p>{t('forgotPassword.checkSpam')}</p>
            <p>{t('forgotPassword.waitMinutes')}</p>
            <p>{t('forgotPassword.checkEmail')}</p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default EsqueciSenhaPage;
